import React, { FC, useContext, useEffect, useState } from "react";

import { UserContext } from "../../lib/context/UserContext";
import { Defect, defects, getAllDefects, getUsedDefects } from "../../lib/api/defects";
import Confirmation from "../../lib/components/confirmation";

import DefectsGrid from "./defectsgrid";
import DefectsEditForm from "./defectseditform";
import { DialogInformation } from "../../lib/components/dialoginformation";

type DefectsProps = {};

const Defects: FC<DefectsProps> = ({ }) => {
  const { user } = useContext(UserContext);

  const [isLocked, setIsLocked] = useState(false);
  const [data, setData] = useState<Defect[]>([]);
  const [loading, setLoading] = useState(false);
  const [confirmEditID, setConfirmEditID] = useState<unknown>(null);
  const [confirmRemoveDefect, setConfirmDefect] = useState<Defect | null>(null);
  const [usedDefects, setUsedDefects] = useState<{ defect: string }[]>([]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [defectsResult, defectsUsedResult] = await Promise.all([getAllDefects(), getUsedDefects()]);
      const dataSorted = defectsResult.sort((a, b) => a.defect.toLowerCase().localeCompare(b.defect.toLowerCase()));
      setUsedDefects(defectsUsedResult);
      setData(dataSorted);
    } catch (error) {
      console.log("🚀 ~ loadData ~ error:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (confirmRemoveDefect && usedDefects.some((d) => d.defect === confirmRemoveDefect.defect)) {
      setIsLocked(true);
      setConfirmDefect(null);
    }
  }, [confirmRemoveDefect]);

  const handleRemoveClose = () => {
    setConfirmDefect(null);
  };

  const handleRemoveConfirm = async () => {
    await defects.remove(confirmRemoveDefect.id);
    handleRemoveClose();
    await loadData();
    localStorage.removeItem("arrivalsgridsetupLayout");
  };

  const handleEditClose = () => {
    setConfirmEditID(null);
  };

  const handleEditConfirm = async (item: Defect) => {
    const id = item["id"];
    delete item["id"];

    if (!id) {
      await defects.create({ data: { ...item, user_updated_by: user.id } });
    } else {
      await defects.update(id, { data: { ...item, user_updated_by: user.id, updated_at: new Date() } });
    }

    await loadData();
    handleEditClose();
    localStorage.removeItem("arrivalsgridsetupLayout");
  };

  return (
    <div>
      {isLocked && (
        <DialogInformation
          isOpen
          showinput={false}
          title="Locked"
          body="Defect is in use. You cannot remove this defect."
          handleOK={() => setIsLocked(false)}
          handleClose={() => setIsLocked(false)}
        />
      )}
      {confirmRemoveDefect && (
        <Confirmation
          isOpen
          handleClose={handleRemoveClose}
          handleConfirm={handleRemoveConfirm}
          title="Remove selected Defect?"
          body="Are you sure you want to REMOVE the selected Defect?"
        />
      )}
      {confirmEditID && (
        <Confirmation isOpen handleConfirm={() => { }} handleClose={handleEditClose} title={confirmEditID == "0" ? "Creating Defect" : "Editing Defect"} body={undefined}>
          <DefectsEditForm onSubmit={handleEditConfirm} onClose={handleEditClose} id={+confirmEditID} />
        </Confirmation>
      )}
      <DefectsGrid data={data} loading={loading} setConfirmEditID={setConfirmEditID} setConfirmDefect={setConfirmDefect} />
    </div>
  );
};

export default Defects;
